export const handbookCopy = {
  handb_prev: "Précédent",
  handb_next: "Suivant",
  handb_on_this_page: "Sur cette page",
  handb_like_dislike_title: "Cette page est-elle utile ?",
  handb_like_desc: "Oui",
  handb_dislike_desc: "Non",
  handb_thanks: "Merci pour votre retour",
  handb_deprecated_title: "Cette page a été dépréciée",
  handb_deprecated_subtitle: "Cette page du guide a été remplacée, ",
  handb_deprecated_subtitle_link: "aller à la nouvelle page",
  handb_deprecated_subtitle_action: "Aller à la nouvelle page",
  handb_experimental_title: "Cette page contient la documentation expérimentale",
  handb_experimental_subtitle: "Le contenu concerne un sujet qui n'est pas encore définitif.",

};
